import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.api.service';

export interface CategoryGridItem {
    id: number;
    row_index: number | null;
    column_index: number | null;
    title: string;
    cat_code: string | null;
    icon_image: string | null;
    link: any;
    created_at?: string;
    updated_at?: string;
    status?: string | null;
    last_released_at?: string | null;
    is_new?: boolean;
}

@Injectable()
export class HomeTabCategoryGridService extends BaseAPIService {

    private ROUTES = {
        list: '/home-tab/category-grid',
        item: '/home-tab/category-grid/:id',
        layoutBulk: '/home-tab/category-grid/layout/bulk',
        preview: '/home-tab/category-grid/preview/:code'
    };

    constructor(protected http: HttpClient) {
        super(http);
    }

    // 전체 목록 조회
    getList(): Promise<CategoryGridItem[]> {
        return this.GET<CategoryGridItem[]>(this.ROUTES.list).toPromise();
    }

    // 단일 아이템 조회
    getItem(id: number): Promise<CategoryGridItem> {
        return this.GET<CategoryGridItem>(this.ROUTES.item, { id }).toPromise();
    }

    // 아이템 생성
    createItem(data: Partial<CategoryGridItem>): Promise<CategoryGridItem> {
        return this.POST<CategoryGridItem>(this.ROUTES.list, null, data).toPromise();
    }

    // 아이템 내용 수정
    updateItem(id: number, data: Partial<CategoryGridItem>): Promise<any> {
        return this.PUT(this.ROUTES.item, { id }, data).toPromise();
    }

    // 아이템 삭제
    deleteItem(id: number): Promise<any> {
        return this.DELETE(this.ROUTES.item, { id }).toPromise();
    }

    // 배치 일괄 저장
    updateLayout(items: Partial<CategoryGridItem>[]): Promise<any> {
        return this.PUT(this.ROUTES.layoutBulk, null, { items }).toPromise();
    }

    // 카테고리 코드로 아이템 미리보기
    previewItemsByCode(code: string): Promise<any> {
        return this.GET(this.ROUTES.preview, { code }).toPromise();
    }
}
